export const LOGIN_USER = 'LOGIN_USER';
export const BLOCK_USER = 'BLOCK_USER';
export const UNBLOCK_USER = 'UNBLOCK_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const UNBLOCK_USER_SUCCESS = 'UNBLOCK_USER_SUCCESS';
export const COMPANY_SUCCESS = 'COMPANY_SUCCESS';

export const MENU_BY_ROLE = 'MENU_BY_ROLE';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const COMAPNY_API_ERROR = 'COMAPNY_API_ERROR';

export const FORGET_USER_SUCCESS = 'FORGET_USER_SUCCESS';
export const FORGET_USER_DONE = 'FORGET_USER_DONE';
export const SOCIAL_LOGIN = 'SOCIAL_LOGIN';
